import React from 'react';
import { motion } from 'framer-motion';
import { SERVICES } from '../data/mockData';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
  const { t, language } = useLanguage();

  return (
    <div className="pt-28 md:pt-32 pb-20 min-h-screen">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }} 
          className="text-center max-w-2xl mx-auto mb-16 md:mb-24"
        >
          <h1 className="font-serif text-4xl md:text-5xl mb-6">{t('services.title')} <br className="hidden sm:block"/>{t('services.titleSuffix')}</h1>
          <p className="text-text-light leading-relaxed">
            {t('services.description')}
          </p>
        </motion.div>

        <div className="space-y-20 md:space-y-32">
          {SERVICES.map((service, index) => (
            <motion.div 
              key={service.id} 
              initial={{ opacity: 0, y: 40 }} 
              whileInView={{ opacity: 1, y: 0 }} 
              viewport={{ once: true }} 
              transition={{ duration: 0.8 }} 
              className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 md:gap-16 items-center`}
            >
              <div className="w-full md:w-1/2 aspect-[4/5] sm:aspect-video md:aspect-[4/5] overflow-hidden shadow-soft">
                <img src={service.image} alt={service.title[language]} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className={`w-full md:w-1/2 flex flex-col justify-center ${index % 2 !== 0 ? 'md:items-end md:text-right' : 'md:items-start text-left'}`}>
                <span className="text-accent uppercase tracking-widest text-sm mb-4 font-bold">{service.price[language]}</span>
                <h2 className="font-serif text-3xl md:text-4xl mb-6">{service.title[language]}</h2>
                <p className="text-text-light leading-relaxed mb-8 max-w-md">{service.description[language]}</p>
                <Link to="/contact" className="w-full sm:w-auto px-10 py-4 bg-text-dark text-white text-center uppercase tracking-widest text-sm font-semibold hover:bg-black transition-colors shadow-lg">
                  {t('services.bookThisService')}
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
